// CSS tools shorcuts for project

// Font-Family
const poppinsExtraLight = {
  fontFamily: "Poppins-ExtraLight",
};
const poppinsExtraLightItalic = {
  fontFamily: "Poppins-ExtraLightItalic",
};
const poppinsLight = {
  fontFamily: "Poppins-Light",
};
const poppinsLightItalic = {
  fontFamily: "Poppins-LightItalic",
};
const poppins = {
  fontFamily: "Poppins",
};
const poppinsItalic = {
  fontFamily: "Poppins-Italic",
};
const poppinsMedium = {
  fontFamily: "Poppins-Medium",
};
const poppinsSemiBold = {
  fontFamily: "Poppins-SemiBold",
};
const poppinsBold = {
  fontFamily: "Poppins-Bold",
};

// Font-Size
const fs10 = {
  fontSize: "10px",
};
const fs11 = {
  fontSize: "11px",
};
const fs12 = {
  fontSize: "12px",
};
const fs13 = {
  fontSize: "13px",
};
const fs14 = {
  fontSize: "14px",
};
const fs15 = {
  fontSize: "15px",
};
const fs16 = {
  fontSize: "16px",
};
const fs17 = {
  fontSize: "17px",
};
const fs18 = {
  fontSize: "18px",
};
const fs19 = {
  fontSize: "19px",
};
const fs20 = {
  fontSize: "20px",
};
const fs21 = {
  fontSize: "21px",
};
const fs36 = {
  fontSize: "36px",
};
const fs70 = {
  fontSize: "70px",
};

// Height
const h100vh = {
  height: "100vh",
};

export {
  fs10,
  fs11,
  fs12,
  fs13,
  fs14,
  fs15,
  fs16,
  fs17,
  fs18,
  fs19,
  fs20,
  fs21,
  fs36,
  fs70,
  h100vh,
  poppins,
  poppinsBold,
  poppinsExtraLight,
  poppinsExtraLightItalic,
  poppinsItalic,
  poppinsLight,
  poppinsLightItalic,
  poppinsMedium,
  poppinsSemiBold,
};
